import { underscore } from '@ember/string';

import ApplicationSerializer from './application';

export default class ReceivableInvoiceSerializer extends ApplicationSerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }

  keyForRelationship(key) {
    return underscore(key);
  }

  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    let { contact_email, logo_url, organization } = payload.data.attributes;
    payload.data.attributes.organization = {
      ...organization,
      contact_email,
      logo: {
        fileUrl: logo_url,
      },
    };

    delete payload.data.attributes.logo_url;

    payload.data.attributes.stamp_duty_amount = payload.data.attributes.stamp_duty_amount?.value;

    return super.normalizeResponse(store, primaryModelClass, payload, id, requestType);
  }
}
